import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import ContentHead from '@Components/customComponents/ContentHead';
import localize from '@Components/localize';
import {useAuth} from '@Services/AuthService/useAuth';
import { linkTo, } from '@Services/navigation';

const ErrorPage = ({translate}) => {
	const { isAuthorized } = useAuth();

	return (
		<div className="content ">
			<div className="content__header flex--row_center-between paddings--sides_40">
				<Link to={isAuthorized() ? linkTo('transactions') : '/'} className='button-grey flex--row_center-center'>
					<span className="color--blue_light">
						{translate('error_page_btn_home')}
					</span>
					<i className="icon-menu icon--dashboard margin--left_8"></i>
				</Link>
				
				
				<ContentHead />
			</div>
			
			<div className="error-content flex--row_center-center">
				<div className="error-image error-image--404" />
				
				<div className="width--px_680 margin--left_40">
					<div className="flex--row_start-end margin--bottom_10">
						<span className="text--extra font--160">404</span>
						<span className="font--32 margin--left_30 margin--bottom_20">{translate('error_page_title')}</span>
					</div>
					<div className="font--noah_medium font--16">
						{translate('error_page_text')}
					</div>
				</div>
			</div>
		</div>
	);
};

ErrorPage.propTypes = {
	translate: PropTypes.func,
};

export default localize(ErrorPage);
